import axios from "axios";

export function fetchData({region, date, id, teamFilter, market}) {
    const paths = '/.netlify/functions/api'

    if(region === 'main'){
      region = null;
    }

    if(date === 'Общая'){
      date = null 
    }
    
    const computablePaths = {
      overall: (region) => `${paths}/overall${region ? `/${region}` : ''}`,
      gamelist: (region) => `${paths}/game_list${region ? `/${region}` : ''}`,
      tournament_overall: (id) => `${paths}/tournament/overall/${id}`,
      tournament_gamelist: (id) => `${paths}/tournament/game_list/${id}`,
    };

    const overall = id ? computablePaths.tournament_overall(id) : computablePaths.overall(region);
    const gameList = id ? computablePaths.tournament_gamelist(id) : computablePaths.gamelist(region);

    const params = {
      ...(id ? {} : {month: date}),
      ...(teamFilter ? {team:teamFilter} : {}),
      ...(market ? {market} : {})
    }

    try {
      const request = axios.get(overall, {
        headers: { "Access-Control-Allow-Origin": "*" },
        params,
      });
      const request2 = axios.get(gameList , {
        headers: { "Access-Control-Allow-Origin": "*" },
        params
      });
      return Promise.all([request,request2]);
    } catch (error) {
      console.log(error);
    }
  }